import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CustomerTradeGroupReferenceService extends BaseReferenceService {
  constructor() {
    super('CustomerTradeGroupReference');
  }
}
